import { BusinessRounded, CloseRounded, ExpandMoreRounded } from '@mui/icons-material'
import { Box, IconButton, Typography } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'
import { BrandsDrawerPaper, LinkButton, StyledDivider, ToggleBrandsButton } from '../../styles/BrandMobileFilterStyles'
import BrandFilter from '../layouts/filters/BrandFilter'
import { CustomButton } from '../ClientMobileMenu'

function BrandMobileFilter({ theme, type }: { theme: string; type: string }) {
  const { t } = useTranslation(['global'])

  const { userBrands } = useSelector((state: IRootState) => state.brand)
  const { globalBrandId } = useSelector((state: IRootState) => state.global)

  const [mobileOpen, setMobileOpen] = useState(false)

  const getBrandName = (): string => {
    let brandName: string = ''
    const objBrand = userBrands.find((brand: any) => brand.id === globalBrandId)
    if (objBrand) brandName = objBrand.name.toUpperCase()

    return brandName
  }

  return (
    <>
      {type === 'nav' ? (
        <Box
          sx={theme => ({
            display: 'flex',
            [theme.breakpoints.up('md')]: {
              display: 'none'
            }
          })}
        >
          <Box sx={{flexWrap: 'wrap'}} display={window.location.pathname !== '/inicio' ? 'flex' : 'none'}>
            <StyledDivider orientation="vertical" flexItem className={theme} />
            <LinkButton className={theme} aria-haspopup="true" underline="none" onClick={() => setMobileOpen(!mobileOpen)}>
              <Typography
                sx={{ whiteSpace: 'nowrap', maxWidth: 96, textOverflow: 'ellipsis', overflow: 'hidden' }}
                variant="body2"
                className={theme}
              >
                {globalBrandId !== 0 && globalBrandId !== null ? getBrandName() : 'MARCAS'}
              </Typography>
              <ExpandMoreRounded />
            </LinkButton>
            <StyledDivider orientation="vertical" flexItem className={theme} />
          </Box>
        </Box>
      ) : (
        <CustomButton sx={{ width: '100%' }} startIcon={<BusinessRounded />} onClick={() => setMobileOpen(!mobileOpen)}>
          <Typography variant="caption" color="textSecondary">
            {t('brands')}
          </Typography>
        </CustomButton>
      )}

      <BrandsDrawerPaper
        variant="temporary"
        anchor="left"
        open={mobileOpen}
        onClose={() => setMobileOpen(!mobileOpen)}
        classes={{ paper: theme }}
        ModalProps={{ keepMounted: true }}
      >
        <IconButton
          onClick={() => setMobileOpen(!mobileOpen)}
          sx={theme => ({
            position: 'fixed',
            right: 8,
            top: 8,
            backgroundColor: theme.palette.common.white
          })}
        >
          <CloseRounded />
        </IconButton>
        <BrandFilter layout={theme} />
      </BrandsDrawerPaper>
    </>
  )
}

export default BrandMobileFilter
